var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"orders-order"},[_c('strong',{staticClass:"mobile-title"},[(_vm.icon)?_c('i',{class:'fas fa-' + _vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.before)+" "+_vm._s(_vm.text != null ? _vm.text : '--')+" "+_vm._s(_vm.after)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }